// @flow
import React, { Component } from 'react';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import local from '../../../../../../../../locales/index';

import style from './style';

class DaySelector extends Component<{
  defaultValue: Array<boolean>,
  onChange: Function,
}, {
  days: Array<boolean>,
}> {
  constructor(props: Object) {
    super(props);
    this.state = {
      days: props.defaultValue,
    };
  }

  isSelected(index: number): boolean {
    return this.state.days[index];
  }

  toggle(index: number) {
    const newDays = this.state.days;
    newDays[index] = !newDays[index];
    this.setState({ days: newDays });
    this.props.onChange(newDays);
  }

  render() {
    return (
      <DropdownButton title={local.medicationDays} key={1} id="daysSelect">
        <MenuItem eventKey="1" onClick={() => this.toggle(0)} style={(this.isSelected(0)) ? style.selected : {}}>{local.monday}</MenuItem>
        <MenuItem eventKey="2" onClick={() => this.toggle(1)} style={(this.isSelected(1)) ? style.selected : {}}>{local.tuesday}</MenuItem>
        <MenuItem eventKey="3" onClick={() => this.toggle(2)} style={(this.isSelected(2)) ? style.selected : {}}>{local.wednesday}</MenuItem>
        <MenuItem eventKey="4" onClick={() => this.toggle(3)} style={(this.isSelected(3)) ? style.selected : {}}>{local.thursday}</MenuItem>
        <MenuItem eventKey="5" onClick={() => this.toggle(4)} style={(this.isSelected(4)) ? style.selected : {}}>{local.friday}</MenuItem>
        <MenuItem eventKey="6" onClick={() => this.toggle(5)} style={(this.isSelected(5)) ? style.selected : {}}>{local.saturday}</MenuItem>
        <MenuItem eventKey="7" onClick={() => this.toggle(6)} style={(this.isSelected(6)) ? style.selected : {}}>{local.sunday}</MenuItem>
      </DropdownButton>
    );
  }
}

export default DaySelector;



// WEBPACK FOOTER //
// ./src/scenes/UserSettings/components/Medication/components/MedicationInput/components/DaySelector/DaySelector.js